// BSA Compliance Register — Building Safety Act duties & statutory checks (Phase 6)
import { ShieldCheck } from "lucide-react";
import RegisterScaffold from "@/components/RegisterScaffold";
import Pill from "@/components/Pill";

const STATUS_TONE = { Compliant: "green", "Due soon": "amber", Overdue: "red", "Not applicable": "neutral" };
const todayIso = () => new Date().toISOString().slice(0, 10);

const config = {
    title: "BSA Compliance Register",
    sectionTag: "Safety & Compliance",
    endpoint: "/bsa",
    testid: "bsa",
    moduleId: "bsa",
    icon: ShieldCheck,
    emptyHint: "No Building Safety Act duties recorded for these buildings yet.",
    filters: [
        { param: "category", metaKey: "categories", allLabel: "All categories" },
        { param: "status", metaKey: "statuses", allLabel: "All statuses" },
    ],
    columns: [
        { key: "requirement", label: "Requirement", render: (r) => <div className="font-semibold text-[#1F1F1F]">{r.requirement}</div> },
        { key: "category", label: "Category" },
        { key: "building_id", label: "Building", render: (r, c) => c.buildingMap[r.building_id]?.name || "—" },
        { key: "frequency", label: "Frequency" },
        { key: "due_date", label: "Due", render: (r) => {
            const overdue = r.status !== "Compliant" && r.due_date && r.due_date < todayIso();
            return <span className={`font-mono text-[11.5px] ${overdue ? "text-[#B43A3A] font-bold" : "text-[#2D2D2D]"}`}>{r.due_date || "—"}</span>;
        } },
        { key: "status", label: "Status", render: (r) => <Pill tone={STATUS_TONE[r.status] || "neutral"}>{r.status}</Pill> },
    ],
    fields: [
        { key: "requirement", label: "Requirement", type: "text", required: true, full: true },
        { key: "category", label: "Category", type: "select", metaKey: "categories", required: true },
        { key: "frequency", label: "Frequency", type: "select", metaKey: "frequencies", default: "Annual" },
        { key: "status", label: "Status", type: "select", metaKey: "statuses", default: "Due soon" },
        { key: "accountable_person", label: "Accountable person", type: "text" },
        { key: "last_completed", label: "Last completed", type: "date" },
        { key: "due_date", label: "Due date", type: "date" },
        { key: "evidence_ref", label: "Evidence reference", type: "text" },
        { key: "notes", label: "Notes", type: "textarea" },
    ],
};

export default function BsaRegisterPage() {
    return <RegisterScaffold config={config} />;
}
